import { useIntl } from 'react-intl'
import InfoTip from '../../../components/novarium/InfoTip'
import { UrgencyDailyPointDTO } from '../../../dto/urgencySummary/UrgencySummaryDTO'
import { PeakAnalysis } from '../../ServicesStatistics/peaks'
import { dayPoint } from '../../ServicesStatistics/periodDetail'
import { parseIsoDate } from '../../ServicesStatistics/statisticsUtils'
import { chipTitle } from '../../ServicesStatistics/TimelineChart'
import { formatCount, formatMinutes } from '../urgencySummaryFormat'

interface UrgencyPeakChipsProps {
  daily: UrgencyDailyPointDTO[]
  analysis: PeakAnalysis
  /** Abre el detalle del día; `opener` es el chip, a donde vuelve el foco al cerrar el panel. */
  onOpen: (day: UrgencyDailyPointDTO, opener: HTMLElement) => void
}

/**
 * «Picos»: un botón por cada pico de espera marcado en el gráfico («Sábado 19/09 · 78,0 min · 241 pacientes ›»), la
 * entrada más fácil con el dedo y con lector de pantalla. Abre el mismo detalle que el click en el gráfico. Sin picos no
 * se muestra nada. El ⓘ dice el criterio, con la cantidad mínima de pacientes que usó el cálculo.
 */
export default function UrgencyPeakChips({ daily, analysis, onOpen }: UrgencyPeakChipsProps) {
  const intl = useIntl()
  if (analysis.peaks.length === 0) return null

  return (
    <div className="nv-urg-peaks">
      <span className="nv-urg-peaks__label">
        <span className="nv-strong" id="nv-urg-peaks-label">{intl.formatMessage({ id: 'UrgencySummaryPeaksTitle' })}</span>
        <InfoTip text={intl.formatMessage({ id: 'UrgencySummaryPeaksCriteria' }, { min: formatCount(intl, analysis.minAttentions) })} />
      </span>
      <ul className="nv-urg-peaks__list" aria-labelledby="nv-urg-peaks-label">
        {analysis.peaks.map((index) => {
          const day = daily[index]
          return (
            <li key={day.date}>
              <button type="button" className="nv-urg-peak-chip" onClick={(event) => onOpen(day, event.currentTarget)}>
                <span>
                  {intl.formatMessage({ id: 'UrgencySummaryPeaksChip' }, {
                    period: chipTitle(intl, dayPoint(parseIsoDate(day.date), day.arrivals, day.avgWaitMinutes, null), 'DAY'),
                    value: formatMinutes(intl, day.avgWaitMinutes),
                    count: day.waitedCount,
                    countText: formatCount(intl, day.waitedCount),
                  })}
                </span>
                <i className="pi pi-angle-right" aria-hidden="true" />
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
